import React from 'react'
import cx from 'classnames'

import s from './OrderStatusBar.module.css'

const OrderStatusBar = ({ color, mini }) => {
  const statusBar = cx(s.orderStatusBar, {
    [s['orderStatusBar--mini']]: mini
  })

  return <div className={statusBar} style={{ backgroundColor: `#${color}` }} />
}

export default OrderStatusBar
